import React, { useContext } from 'react';
import { FuelIcon, FuelTypography } from '@frete.com/fuel-react';
import AppContext from '@context';
import When from '@components/ui/When';
import Proposal from './Proposal';
import Skeleton from './Skeleton';
import { JourneyListProposalsDesktopPropsInterface } from './JourneyListProposalsDesktopTypes';
import * as Styled from './JourneyListProposalsDesktopStyles';

function JourneyListProposalsDesktop({
  handleClick,
}: JourneyListProposalsDesktopPropsInterface) {
  const {
    state: {
      proposals: { pending: proposals },
      journeys: { all },
      filters: { isSearching },
    },
  } = useContext(AppContext);
  const loading = proposals.isFetching;

  function renderProposals() {
    return proposals.data.map((proposal, index, array) => (
      <Proposal
        key={proposal.id}
        {...proposal}
        hasBorder={!!all.data.length || index + 1 !== array.length}
        onClick={(event) => {
          handleClick(event, proposal);
        }}
      />
    ));
  }

  return (
    <>
      <When isShow={!loading && !isSearching}>
        <FuelTypography size="body-md" weight="bold" spacingBottom={24}>
          <Styled.WrapperTitle>
            <FuelIcon name="notification-bell" iconStyle="filled" />
            Viagens pendentes de confirmação:
          </Styled.WrapperTitle>
        </FuelTypography>
        {renderProposals()}
      </When>
      <When isShow={loading}>
        <Skeleton />
      </When>
    </>
  );
}

export default JourneyListProposalsDesktop;
